//
// VisualContainerElement.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./VisualElement";
import "../view/layout/stackNavigation/StackNavigationControl";
import "./VisualContainerType";

var VisualContainerElement = createModule("BIRD::VisualContainerElement", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::VisualElement"], EventDispatcher, [
    ,
    {
        containerType: 4,
        stackNavigationControl: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default VisualContainerElement;
